import React from 'react';
import { Scale, Copyright, Lightbulb, Building2, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { coreServices } from '../data/mock';
import { openChat } from '../utils/chat';

const iconMap = {
  'Trademark Registration': Scale,
  'Copyright Registration': Copyright,
  'Patent Services': Lightbulb,
  'Company Formation': Building2,
};

export const Services = ({ onOpenForm }) => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-[#D4AF37] font-semibold text-sm uppercase tracking-wider">Our Services</span>
          <h2 className="text-4xl md:text-5xl font-bold text-[#0A1F44] mt-4 mb-6">
            Comprehensive Intellectual Property Solutions
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            From strategic trademark registration to sophisticated patent applications, we deliver integrated legal services that safeguard every dimension of your intellectual property portfolio.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {coreServices.map((service) => {
            const Icon = iconMap[service.title];
            return (
              <div
                key={service.id}
                className="group bg-white rounded-2xl p-8 shadow-md hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
              >
                <div className="flex items-start space-x-6">
                  <div className="flex-shrink-0">
                    <div className="w-16 h-16 bg-[#0A1F44] rounded-xl flex items-center justify-center group-hover:bg-[#D4AF37] transition-colors duration-300">
                      <Icon className="w-8 h-8 text-[#D4AF37] group-hover:text-[#0A1F44]" />
                    </div>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold text-[#0A1F44] mb-3">{service.title}</h3>
                    <p className="text-gray-600 leading-relaxed mb-4">{service.description}</p>
                    <a
                      href={service.link}
                      className="inline-flex items-center space-x-2 text-[#D4AF37] hover:text-[#0A1F44] font-semibold transition-colors duration-200"
                    >
                      <span>Learn More</span>
                      <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                    </a>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Additional Services Banner */}
        <div className="mt-16 bg-gradient-to-r from-[#0A1F44] via-[#153356] to-[#0A1F44] rounded-2xl p-10 text-center">
          <h3 className="text-3xl font-bold text-white mb-4">Amazon Brand Registry Assistance</h3>
          <p className="text-gray-300 text-lg mb-6 max-w-2xl mx-auto">
            Protect your Amazon brand from counterfeiters and unauthorized sellers with our expert trademark registration and Brand Registry enrollment services.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button 
              onClick={onOpenForm}
              className="liquid bg-[#D4AF37] hover:bg-[#B8941F] text-[#0A1F44] font-bold px-8 py-3 text-lg"
            >
              Start Trademark Registration
            </Button>
            <Button
              onClick={openChat}
              variant="outline"
              className="liquid-outline border-2 border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37] hover:text-white font-bold px-8 py-3 text-lg"
            >
              Discuss with Attorney
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};